import { BannerAnalyticsData } from '@analytics/const';
import { PromoAnalyticsService } from '@analytics/feature';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  OnDestroy,
  OnInit,
  Optional,
  Output,
} from '@angular/core';
import { CustomCmsBannerComponent } from '@promo/const';
import { CmsComponentData, PageSlotComponent } from '@spartacus/storefront';
import { Observable, Subscription } from 'rxjs';
import { distinctUntilChanged, filter, map, take } from 'rxjs/operators';

@Component({
  selector: 'sd-simple-banner',
  templateUrl: './simple-banner.component.html',
  styleUrls: ['./simple-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdSimpleBannerComponent implements OnInit, OnDestroy {
  @HostBinding('class') bannerClass: string;

  @Output() bannerClassEvent: EventEmitter<string> = new EventEmitter();

  bannerAnalyticsData$: Observable<BannerAnalyticsData>;

  private subscription = new Subscription();

  constructor(
    public component: CmsComponentData<CustomCmsBannerComponent>,
    private promoAnalyticsService: PromoAnalyticsService,
    @Optional() private pageSlotComponent: PageSlotComponent,
  ) {}

  ngOnInit(): void {
    this.subscription.add(
      this.getBannerClass().subscribe((bannerClass) => {
        // если симпл баннер лежит внутри рандом баннера,
        // то класс должен примениться к обертке
        if (this.bannerClassEvent.observed) {
          this.bannerClassEvent.emit(bannerClass);
        } else {
          this.bannerClass = bannerClass;
        }
      }),
    );

    this.bannerAnalyticsData$ = this.component.data$.pipe(
      filter<CustomCmsBannerComponent>(Boolean),
      map((data) => ({
        id: data.uid,
        name: data.name,
        position: this.pageSlotComponent.position,
      })),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  getBannerClass(): Observable<string> {
    return this.component.data$.pipe(filter((data) => Boolean(data))).pipe(
      map((data) => {
        return [
          // в мобильной версии баннер должен занимать все 12 колонок
          'col-12',
          // начиная с sm версии баннер должен занимать
          // кол-во колонок указанное в настройках компонента или
          // 12 колонок, если значение не указано
          data.bannerFormat && data.bannerFormat.replace('F', 'col-sm-'),
        ]
          .filter(Boolean)
          .join(' ');
      }),
      distinctUntilChanged(),
    );
  }

  onBannerClick(): void {
    this.bannerAnalyticsData$.pipe(take(1)).subscribe((data: BannerAnalyticsData) => {
      this.promoAnalyticsService.onClickBanner(data);
    });
  }

  onBannerIntersect(): void {
    this.bannerAnalyticsData$.pipe(take(1)).subscribe((data: BannerAnalyticsData) => {
      this.promoAnalyticsService.onShowBanner(data);
    });
  }
}
